import { createStore } from "vuex"
import { useCookies } from "vue3-cookies"

const { cookies } = useCookies()

const store = createStore({
	state: {
		backend: process.env.NODE_ENV === "development" ?  "http://localhost:8501/api" : `${location.protocol}//${location.hostname}${location.port !== "" ? ":"+location.port : ""}/api`,
		admin: {
			token: cookies.get("token") ?? null,
			login: null,
			verified: true
		}
	}
})

export default store